import React from "react";

import Latzhose from "../Garments/LatzhosePrimo";

export default function LatzhosePage() {
  return <Latzhose />;
}
